export function normalizeSaltComposition(input: any): { name: string; strength: string }[] {
  if (!Array.isArray(input)) return [];

  return input.map(item => {
    if (typeof item === 'string') {
      try {
        return JSON.parse(item);
      } catch (e) {
        console.warn('Invalid JSON string in saltComposition:', item);
        return null;
      }
    }
    if (typeof item === 'object' && item !== null) {
      return item;
    }
    return null;
  }).filter(Boolean); // remove nulls
}